import { render, staticRenderFns } from "./IncidentsListEdit.vue?vue&type=template&id=28616990"
import script from "./IncidentsListEdit.vue?vue&type=script&lang=js"
export * from "./IncidentsListEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports